<div id="multi-line-chart-div" style="width: 100%; height: 500px"></div>
